import { useEffect, useState } from 'react';
import { CreditCard } from 'lucide-react';

export const COMPANY_LABEL = { LC: 'LUX Construction', LD: 'LUX Developments' };
export const normCompany = (c) => (!c ? null : ['LC', 'CON'].includes(String(c).toUpperCase()) ? 'LC' : 'LD');
export const accountFor = (s, company) => { const c = normCompany(company); return !s || !c ? null : (c === 'LC' ? s.account_lc : s.account_ld) || null; };
export const matchSupplier = (list, name) => (list || []).find(s => s.name.toLowerCase() === String(name || '').trim().toLowerCase()) || null;

/** Curated order suppliers (Settings → Order suppliers) — cached per mount. */
export function useOrderSuppliers(api) {
  const [list, setList] = useState([]);
  useEffect(() => { api.get('/order-suppliers').then(r => setList(r.data || [])).catch(() => setList([])); }, [api]);
  return list;
}

/** Capture screen: account number hint when the typed supplier is on the curated list. */
export function CaptureSupplierAccount({ api, supplierName, company }) {
  const suppliers = useOrderSuppliers(api);
  const s = matchSupplier(suppliers, supplierName);
  if (!s) return null;
  return <div className="mt-3" data-testid="capture-supplier-account"><AccountNumberCard supplier={s} company={company} compact /></div>;
}

/**
 * The account number to quote — large, unmissable. With a company: one big
 * number; without: both companies side by side until the project is picked.
 */
export function AccountNumberCard({ supplier, company, compact = false }) {
  if (!supplier) return null;
  const c = normCompany(company);
  const tone = (k) => (k === 'LC' ? { text: 'text-blue-300', border: 'border-blue-500/40', bg: 'bg-blue-500/10' } : { text: 'text-[#F5A623]', border: 'border-[#F5A623]/40', bg: 'bg-[#F5A623]/10' });
  const one = (k) => {
    const acc = accountFor(supplier, k);
    const t = tone(k);
    return (
      <div key={k} className={`flex-1 rounded-xl border p-3 ${t.border} ${t.bg}`} data-testid={`account-number-${k}`}>
        <div className="text-[11px] uppercase tracking-wide text-gray-400">{COMPANY_LABEL[k]}</div>
        <div className={`${compact ? 'text-xl' : 'text-3xl'} font-black tabular-nums tracking-wide ${acc ? t.text : 'text-gray-500'}`} data-testid={`account-number-value-${k}`}>{acc || 'No account no.'}</div>
      </div>
    );
  };
  return (
    <div className="rounded-2xl bg-[#2A3240] border border-white/10 p-3 space-y-2" data-testid="account-number-card">
      <div className="flex items-center gap-2 text-sm text-white font-semibold"><CreditCard className="w-4 h-4 text-[#F5A623]" /> Account number at {supplier.name}</div>
      <div className="flex gap-2">{c ? one(c) : ['LC', 'LD'].map(one)}</div>
      {!c && <p className="text-[11px] text-gray-500">Pick the project below to confirm which company's account to quote.</p>}
    </div>
  );
}
